export const money = value => value == null || !Number.isFinite(Number(value))
  ? 'Needs review' : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);

export function filterActivity(rows, { deal = '', start = '', end = '', status = '', kind = '' }) {
  return rows.filter(row => (!deal || row.deal_id === deal) && (!status || row.status === status)
    && (!kind || row.kind === kind)
    && ((!start && !end) || (row.date && (!start || row.date >= start) && (!end || row.date <= end))));
}

export function csvCell(value) {
  let text = value == null ? '' : String(value);
  if (typeof value !== 'number' && /^[\s]*[=+\-@]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
}

export function withdrawalCsv(rows, investor, generatedAt) {
  const cells = [['Investor', 'Generated at', 'Date', 'Deal', 'Kind', 'Status', 'Amount', 'Included in withdrawals', 'Reference', 'Allocation', 'Record ID']];
  rows.forEach(r => cells.push([investor, generatedAt, r.date || 'Date not recorded', r.deal_name, r.kind,
    r.status, r.amount, r.counts_in_withdrawals ? 'Yes' : 'No', r.reference, r.allocation, r.id]));
  return '\uFEFF' + cells.map(row => row.map(csvCell).join(',')).join('\r\n');
}

export function dealCsv(rows, investor, generatedAt) {
  const cells = [['Investor', 'Generated at', 'Deal number', 'Deal', 'Status', 'Syndication %', 'Collections incl. principal',
    'Current origination entitlement (not posted cash)', 'Default adjustment', 'Recorded collection withdrawals',
    'Collection balance (before pending requests)', 'Itemized collection withdrawals', 'Withdrawal history difference',
    'Funding contribution', 'Broker commission', 'Underwriter fee', 'Total contribution terms', 'Accounting review']];
  rows.forEach(r => cells.push([investor, generatedAt, r.deal_number, r.deal_name, r.status, r.ownership_percentage,
    r.collections, r.current_fee_entitlement, r.default_adjustment, r.recorded_withdrawals, r.collection_balance,
    r.itemized_withdrawals, r.withdrawal_history_difference, r.funding_contribution, r.broker_commission,
    r.underwriter_fee, r.total_contribution, r.accounting_review ? 'Yes' : 'No']));
  return '\uFEFF' + cells.map(row => row.map(csvCell).join(',')).join('\r\n');
}

export function feeCsv(rows, investor, generatedAt) {
  const cells = [['Investor', 'Generated at', 'Date', 'Deal', 'Entry type', 'Amount', 'Reference', 'Record ID']];
  rows.forEach(r => cells.push([investor, generatedAt, r.date || 'Date not recorded', r.deal_name, r.type, r.amount, r.reference, r.id]));
  return '\uFEFF' + cells.map(row => row.map(csvCell).join(',')).join('\r\n');
}

export function downloadCsv(content, filename) {
  const url = URL.createObjectURL(new Blob([content], { type: 'text/csv;charset=utf-8;' }));
  const link = document.createElement('a'); link.href = url; link.download = filename;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
